import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchAnalyticsData, applyRecommendation, fetchAppliedInsights, ApplyRecommendationInput } from '@/api/analytics';

export function useAnalytics(propertyId: string) {
  return useQuery({
    queryKey: ['analytics', propertyId],
    queryFn: () => fetchAnalyticsData(propertyId),
    enabled: !!propertyId,
  });
}

export function useAppliedInsights(propertyId: string) {
  return useQuery({
    queryKey: ['applied-insights', propertyId],
    queryFn: () => fetchAppliedInsights(propertyId),
    enabled: !!propertyId,
  });
}

export function useApplyRecommendation(propertyId: string) {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (input: ApplyRecommendationInput) => applyRecommendation(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['applied-insights', propertyId] });
    },
  });
}
